import { parseXmlDate2 } from "../../../utility/date.helpers";

// [DataSourceNode] -> [DateTime]
export function getHolidayList(holidays) {
    var holidayList = [];

    if (!holidays || holidays.length === 0) {
        holidayList.push(new Date(1900, 0, 1));

        return holidayList;
    }

    holidayList = holidays.map(function (holidayNode) {
        var dt = parseXmlDate2(holidayNode.value());
        return dt.date;
    });

    return holidayList;
}

// ([DateTime], DateTime) -> Boolean
export const isHolidayDate = (holidayList, currentDate) =>
    holidayList.some(function (hDate) {
        hDate = new Date(Date.UTC(hDate.getUTCFullYear(), hDate.getUTCMonth(), hDate.getUTCDate()));
        return hDate - currentDate === 0;
    })


export function isWeekendDay(dt) {
    var day = dt.getUTCDay();
    return day === 0 || day === 6;
}
